// to return error response from API
export const errorResponse = (errors) => {
  // const errorMessage = errors;
  let error={
    status:0,
    errorMessage:errors
  }
  return error;
}